import { Injectable } from '@angular/core';

import { ITableRow } from '../components/util/table/interfaces/table-row.interface';

@Injectable({ providedIn: 'root' })
export class TableService {
    public set highlightOnRefresh(value: string) {
        const set = this._highlightOnRefresh;
        set.add(value);

        while (set.size > 10) {
            const [first] = set;
            set.delete(first);
        }
    }

    private _highlightOnRefresh: Set<string> = new Set<string>();

    public getRowsToFlash(data: Array<ITableRow<{ id: string }>>): Array<string> {
        return data.filter((row) => this._highlightOnRefresh.delete(row.value.id)).map((row) => row.value.id);
    }
}
